import PropTypes from 'prop-types';
import React from 'react';

import Image from '$partials/media/image';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleTicker = ({
    id,
    items,
    displayTitle,
    showDisplayTitle,
    parent
}) => {
    id = id || 'default';
    items = items?.items?.filter(item => !!item.logo) || [];
    if (!items.length) {
        return null;
    }

    // Duplicate messages to fill screen
    let displayedLogo = items;
    while (displayedLogo.length < 4) {
        displayedLogo = displayedLogo.concat(items);
    }

    // Duplicate messages to handle overflow repeats
    const duplicateCount = 4;
    let duplicatedLogos = [];
    for (let i = 0; i < duplicateCount; i++) {
        duplicatedLogos = duplicatedLogos.concat(displayedLogo);
    }

    const totalWidth = displayedLogo.reduce((partialSum, a) => partialSum + a.logo?.width, 0);
    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className={'bg-white overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2'}>
                    {showDisplayTitle && displayTitle && (
                        <div className='layout-container mb-40'>
                            <h3 className='w-full sm:w-8/12 md:w-6/12 px-10 sm:max-md:px-5 type-style-3'>{displayTitle}</h3>
                        </div>
                    )}
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        .ticker-${id} {
                            animation-duration: ${(totalWidth / 1440 * 100) * 0.5}s;
                        }
                    `}} />
                    <ul className={`ticker ticker-${id}`}>
                        {duplicatedLogos.map((item, i) => {
                            if (!item) { return null;}
                            const defaultAttributes = item.link ? {
                                rel: 'noopener noreferrer',
                                target:'_blank',
                                href: item.link
                            } : {};
                            const ComponentTag = item.link ? 'a' : 'div';
                            return (
                                <li
                                    className={'ticker__item inline-block mr-80 md:mr-180 text-[36px] md:text-[50px]'}
                                    key={i}
                                    style={{
                                        width: `${(item.logo?.width / item.logo?.height)}em` ,
                                        maxWidth: '100%',
                                    }}>
                                    <ComponentTag
                                        {...defaultAttributes}>
                                        <Image
                                            {...item.logo}
                                            loading={''}/>
                                    </ComponentTag>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    id: PropTypes.string,
    items: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    displayTitle: PropTypes.string,
    showDisplayTitle: PropTypes.bool,
    parent: PropTypes.string,
};

ModuleTicker.propTypes = propTypes;

export default ModuleTicker;
